import { ProductOverviewGalleries } from './modules/product-overview-galleries';

const productOverviewGalleries = new ProductOverviewGalleries();

window.addEventListener('load', function () {

	// product image galleries
	productOverviewGalleries.setup();
});